@if (showPrompt()) {
  <div class="security-banner">
    <div class="prompt-content">
      <div class="icon-container">
        <mat-icon fontSet="material-symbols-rounded">security</mat-icon>
      </div>
      <div class="text-wrapper">
        <span class="title">{{ 'secureYourAccount' | translate }}</span>
        <span class="subtitle">{{ 'addPasswordDescription' | translate }}</span>
      </div>
    </div>
    <div class="actions">
      <button mat-button class="dismiss-btn" (click)="dismiss()">
        {{ 'maybeLater' | translate }}
      </button>
      <button matButton="filled" color="primary" (click)="setPassword()">
        {{ 'setPassword' | translate }}
      </button>
    </div>
  </div>
}
